// import React from 'react';
// import {
//   FormControl,
//   FormControlLabel,
//   Radio,
//   RadioGroup as MuiRadioGroup,
//   Typography,
//   FormHelperText,
//   useMediaQuery,
//   Box,
// } from '@mui/material';
// import { useTheme } from '@mui/styles';

// // import useStyles from './styles';

// export default function RadioGroup(props) {
//   const {
//     name,
//     label,
//     value,
//     onChange,
//     items,
//     labelPlacement,
//     optionsFontStyle,
//     optionsFontSize,
//     error,
//     helperText,
//     firstLabel,
//     secondLabel,
//     ...other
//   } = props;

//   // const classes = useStyles(props);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//   return (
//     <FormControl error={error ? true : false}>
//       <MuiRadioGroup
//         name={name}
//         value={value}
//         // className={classes.root}
//         sx={{
//           flexWrap: isMobile ? 'wrap' : 'nowrap', // Wrap items on mobile
//         }}
//         onChange={onChange}
//         {...other}
//       >
//         {items.map((item, index) => (
//           <FormControlLabel
//             key={item.id}
//             value={item.id}
//             control={
//               <Radio
//                 // className={classes.radio}
//                 size="small"
//                 disableRipple
//                 sx={{
//                   p: isMobile ? '6px' : '6px',
//                   // border: '1px solid',
//                 }}
//               />
//             }
//             label={
//               <Typography
//                 // variant="body3"
//                 sx={{
//                   fontFamily: optionsFontStyle
//                     ? `${optionsFontStyle}!important`
//                     : 'Poppins',
//                   fontSize: optionsFontSize
//                     ? `${optionsFontSize}px`
//                     : '0.875rem',
//                   margin: !isMobile ? 1 : '0px',
//                   '& .MuiFormControlLabel-label': {
//                     margin: '0px',
//                   },
//                 }}
//               >
//                 {item.title}
//               </Typography>
//             }
//             labelPlacement={labelPlacement || 'end'}
//             sx={{
//               margin: isMobile ? '1px' : '8px',
//               '& .MuiFormControlLabel-label': {
//                 margin: '0px',
//               },
//             }}
//           />
//         ))}
//       </MuiRadioGroup>
//       <Box
//         sx={{
//           // border: '1px solid',
//           display: 'flex',
//           direction: 'row',
//           justifyContent: 'space-between',
//         }}
//       >
//         <Typography
//           sx={{
//             marginLeft: 1,
//             fontFamily: optionsFontStyle ? `${optionsFontStyle}` : 'Poppins',
//             fontSize: optionsFontSize ? `${optionsFontSize}px` : '1rem',
//           }}
//         >
//           {firstLabel}
//         </Typography>
//         <Typography
//           sx={{
//             marginRight: 1,
//             fontFamily: optionsFontStyle ? `${optionsFontStyle}` : 'Poppins',
//             fontSize: optionsFontSize ? `${optionsFontSize}px` : '1rem',
//           }}
//         >
//           {secondLabel}
//         </Typography>
//       </Box>
//       {error && (
//         <FormHelperText variant="body4" color="error">
//           {error}
//         </FormHelperText>
//       )}
//     </FormControl>
//   );
// }

import React from 'react';
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup as MuiRadioGroup,
  Typography,
  FormHelperText,
  useMediaQuery,
  Box,
} from '@mui/material';
import { useTheme } from '@mui/styles';

export default function RadioGroup(props) {
  const {
    name,
    label,
    value,
    onChange,
    items,
    labelPlacement,
    optionsFontStyle,
    optionsFontSize,
    error,
    helperText,
    firstLabel,
    secondLabel,
    ...other
  } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isMedium = useMediaQuery(theme.breakpoints.down('md')) && !isMobile;

  return (
    <FormControl error={error ? true : false}>
      <MuiRadioGroup
        name={name}
        value={value}
        sx={{
          flexWrap: isMobile ? 'wrap' : isMedium ? 'row' : 'nowrap',
          justifyContent: isMedium ? 'center' : 'flex-start',
        }}
        onChange={onChange}
        {...other}
      >
        {items.map((item, index) => (
          <FormControlLabel
            key={item.id}
            value={item.id}
            control={
              <Radio
                size="small"
                disableRipple
                sx={{
                  p: isMobile ? '4px' : '6px',
                }}
              />
            }
            label={
              <Typography
                sx={{
                  fontFamily: optionsFontStyle
                    ? `${optionsFontStyle}!important`
                    : 'Poppins',
                  fontSize: optionsFontSize ? `${optionsFontSize}px` : '1rem',
                }}
              >
                {item.title}
              </Typography>
            }
            labelPlacement={labelPlacement || 'end'}
            sx={{
              margin: isMobile ? '1px' : '0px',
              '& .MuiFormControlLabel-label': {
                margin: '0px',
              },
            }}
          />
        ))}
      </MuiRadioGroup>
      <Box
        sx={{
          display: 'flex',
          justifyContent: isMedium ? 'center' : 'space-between',
        }}
      >
        <Typography
          sx={{
            marginLeft: 1,
            fontFamily: optionsFontStyle ? `${optionsFontStyle}` : 'Poppins',
            fontSize: optionsFontSize ? `${optionsFontSize}px` : '1rem',
          }}
        >
          {firstLabel}
        </Typography>
        <Typography
          sx={{
            marginRight: 1,
            fontFamily: optionsFontStyle ? `${optionsFontStyle}` : 'Poppins',
            fontSize: optionsFontSize ? `${optionsFontSize}px` : '1rem',
          }}
        >
          {secondLabel}
        </Typography>
      </Box>
      {error && (
        <FormHelperText variant="body4" color="error">
          {error}
        </FormHelperText>
      )}
    </FormControl>
  );
}
